<div class="app-habitation-v2">
  <app-hero-banner [image]="headerImage">
    <div class="titre-page">
      <ng-content select="h1.titre-page"></ng-content>
    </div>
  </app-hero-banner>

  <app-habitation-page-container>
    <div class="page-content">
      <section class="text-content">
        <ng-content select="h2.titre-section"></ng-content>

        <ng-content select="section.text-content"></ng-content>

        <button
          *ngIf="!disableReturnButton"
          mat-button
          class="button-back no-border"
          id="btn-rtn-accueil"
          (click)="navigateTo('')"
        >
          <img
            src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}"
            alt=""
            class="button-icone-left"
          />
          {{ 'btn.retour-accueil' | translate }}
        </button>
        <ng-content select="button.action-btn"></ng-content>
      </section>

      <div class="side-information" *ngIf="hasCapsuleConseil">
        <div class="item capsule-container">
          <app-capsule-conseil
            appearance="rounded-outline"
            [titre]="capsuleConseilTitre"
            [isLinesGreaterThan4]="isLinesGreaterThan4"
          >
            <div class="capsule-content">
              <p [innerHtml]="capsuleConseilTexte"></p>
              <div id="info-bulle-with-tooltips" class="info-bulle-with-tooltips" *ngIf="capsuleAvecInfoBulle">
                <ul>
                  <li *ngFor="let line of capsuleAvecInfoBulle" class="capsule-info-bulle-line-item">
                    <span [innerHTML]="line.lien"></span>
                    <app-tooltip
                      [titre]="line.titre"
                      [texte]="line.texte"
                      [altText]="line.altText || ''"
                      [placement]="'bottom'"
                      class="info-bulle-bonidollar"
                    >
                    </app-tooltip>
                  </li>
                </ul>
              </div>
            </div>
          </app-capsule-conseil>
        </div>
      </div>
    </div>
  </app-habitation-page-container>
</div>
